import { CateringChefMenuItem } from '@types'

export enum MenuItemModVerb {
  Add = 'add',
  Remove = 'remove',
  Substitute = 'substitute',
  Includes = 'includes',
  Pick = 'pick',
}

export interface MenuItemModVerbConfig {
  verb: MenuItemModVerb
  isRequired: boolean
  isSingleOpt?: boolean
}

export const verbConfigs: Record<MenuItemModVerb, MenuItemModVerbConfig> = {
  [MenuItemModVerb.Add]: {
    verb: MenuItemModVerb.Add,
    isSingleOpt: false,
    isRequired: false,
  },
  [MenuItemModVerb.Includes]: {
    verb: MenuItemModVerb.Includes,
    isSingleOpt: false,
    isRequired: true,
  },
  [MenuItemModVerb.Pick]: {
    verb: MenuItemModVerb.Pick,
    isRequired: true,
  },
  [MenuItemModVerb.Remove]: {
    verb: MenuItemModVerb.Remove,
    isSingleOpt: false,
    isRequired: false,
  },
  [MenuItemModVerb.Substitute]: {
    verb: MenuItemModVerb.Substitute,
    isSingleOpt: true,
    isRequired: false,
  },
}

export interface MenuItemMod {
  id: string
  name: string
  position: number
  clientPrice: number
  restaurantPrice: number
  retailPrice: number
  deletedAt?: string | null
  createdAt: string
  updatedAt: string
}

export interface MenuItemModGroup {
  id: string
  name: string
  verb: MenuItemModVerb
  isSingleOpt: boolean
  isRequired: boolean
  position: number
  deletedAt?: string | null
  createdAt: string
  updatedAt: string
  mods: MenuItemMod[]
}

export interface ChefMenuItem {
  id: string
  chefId: string
  modsActive: boolean
  availableModGroups: MenuItemModGroup[]
  composedItemIds?: string[]
  composedItems?: Partial<CateringChefMenuItem>[]
  customizableItemId?: string
  customizableItem?: Partial<CateringChefMenuItem>
}

// --- Request Types ---

export interface SearchChefMenuItemReq {
  chefId?: string
  chefMenuItemIds?: string[]
}

export interface CreateChefMenuItemReq {
  chefId: string
  chefMenuItemId: string
  modsActive: boolean
  availableModGroups: CreateMenuItemModGroup[]
}

export interface EditChefMenuItemReq {
  id: string
  modsActive?: boolean
  createAvailableModGroups?: CreateMenuItemModGroup[]
  editAvailableModGroups?: EditMenuItemModGroup[]
}

export interface CreateMenuItemModGroup {
  name: string
  verb: MenuItemModVerb
  isSingleOpt?: boolean
  position: number
  mods: CreateMenuItemMod[]
}

export interface EditMenuItemModGroup {
  id: string
  position?: number
  deleted?: boolean
  createdMods?: CreateMenuItemMod[]
  editedMods?: EditMenuItemMod[]
}

export interface CreateMenuItemMod {
  name: string
  clientPrice: number
  restaurantPrice: number
  retailPrice: number
  position: number
}

export interface EditMenuItemMod {
  id: string
  position?: number
  deleted?: boolean
}
